import { BaseModel } from "../base-model";
import { IGenericObject, GenericObject } from "../common";

export interface IKeuringsPlatformInfoModel {
  Id?: string;
  TypeId?: number;
  FirstName?: string;
  Name?: string;
  Reference?: string;
  CompanyName?: string;
  VATNumber?: string;
  Address?: string;
  Address2?: string;
  HouseNumber?: string;
  BoxNumber?: string;
  PostCode?: string;
  CityName?: string;
  LanguageId?: number;
  CountryId?: number;
  Emails?: Array<string>;
  Email?: string;
  Email2?: string;
  Email3?: string;
  PhoneNumbers?: Array<string>;
  PhoneNumber?: string;
  PhoneNumber2?: string;
  PhoneNumber3?: string;
  IsSelected?: boolean;
  Description?: string;
  VAT?: string;
  IsCompany?: boolean;
  Type?: string;
  NationalityId?: number;
  IDCardNumber?: string;
  Birthday?: string;
  Birthplace?: string;
  CountryName?: string;
  RegionName?: string;
  NationalityName?: string;
  ConstructionId?: string;
  AccountNumber?: string;
  SmoovedGender?: string;
  PropertyBoxNumber?: string;
}

export class KeuringsPlatformInfoModel extends BaseModel<IKeuringsPlatformInfoModel> implements IKeuringsPlatformInfoModel {
  Id?: string;
  TypeId?: number;
  FirstName?: string;
  Name?: string;
  Reference?: string;
  CompanyName?: string;
  VATNumber?: string;
  Address?: string;
  Address2?: string;
  HouseNumber?: string;
  BoxNumber?: string;
  PostCode?: string;
  CityName?: string;
  LanguageId?: number;
  CountryId?: number;
  Emails?: Array<string>;
  Email?: string;
  Email2?: string;
  Email3?: string;
  PhoneNumbers?: Array<string>;
  PhoneNumber?: string;
  PhoneNumber2?: string;
  PhoneNumber3?: string;
  IsSelected?: boolean;
  Description?: string;
  VAT?: string;
  IsCompany?: boolean;
  NationalityId?: number;
  IDCardNumber?: string;
  Birthday?: string;
  Birthplace?: string;
  CountryName?: string;
  RegionName?: string;
  NationalityName?: string;
  PropertyBoxNumber?: string;
  constructor(option?: IKeuringsPlatformInfoModel) {
    super(option);
    this.Id = option.Id || null;
    this.TypeId = option.TypeId || null;
    this.FirstName = option.FirstName || null;
    this.Name = option.Name || null;
    this.Reference = option.Reference || null;
    this.CompanyName = option.CompanyName || null;
    this.VATNumber = option.VATNumber || null;
    this.Address = option.Address || null;
    this.Address2 = option.Address2 || null;
    this.HouseNumber = option.HouseNumber || null;
    this.BoxNumber = option.BoxNumber || null;
    this.PostCode = option.PostCode || null;
    this.CityName = option.CityName || null;
    this.LanguageId = option.LanguageId || null;
    this.CountryId = option.CountryId || null;
    this.Emails = option.Emails || [];
    this.Email = option.Email || null;
    this.Email2 = option.Email2 || null;
    this.Email3 = option.Email3 || null;
    this.PhoneNumbers = option.PhoneNumbers || [];
    this.PhoneNumber = option.PhoneNumber || null;
    this.PhoneNumber2 = option.PhoneNumber2 || null;
    this.PhoneNumber3 = option.PhoneNumber3 || null;
    this.IsSelected = option.IsSelected || null;
    this.Description = option.Description || null;
    this.VAT = option.VAT || null;
    this.IsCompany = option.IsCompany || null;
    this.NationalityId = option.NationalityId || null;
    this.IDCardNumber = option.IDCardNumber || null;
    this.Birthday = option.Birthday || null;
    this.Birthplace = option.Birthplace || null;
    this.CountryName = option.CountryName || null;
    this.RegionName = option.RegionName || null;
    this.NationalityName = option.NationalityName || null;
    this.PropertyBoxNumber = option.PropertyBoxNumber || null;
  }
}

export interface ICertinergieInfoResponse {
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyBoxNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  ExtraInformation?: string;
  PropertyTypes?: IGenericObject;
  CombineInspections?: IGenericObject;
  Regions?: IGenericObject;
  Countries?: IGenericObject;
  AgencyInfos?: IKeuringsPlatformInfoModel[];
  OwnerInfos?: IKeuringsPlatformInfoModel[];
  ContactInfos?: IKeuringsPlatformInfoModel[];
}

export class CertinergieInfoResponseModel extends BaseModel<ICertinergieInfoResponse> implements ICertinergieInfoResponse {
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyBoxNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  ExtraInformation?: string;
  PropertyTypes?: IGenericObject;
  CombineInspections?: IGenericObject;
  Regions?: IGenericObject;
  Countries?: IGenericObject;
  AgencyInfos?: IKeuringsPlatformInfoModel[];
  OwnerInfos?: IKeuringsPlatformInfoModel[];
  ContactInfos?: IKeuringsPlatformInfoModel[];
  constructor(option?: ICertinergieInfoResponse) {
    super(option);
    this.PropertyAddress = option.PropertyAddress;
    this.PropertyHouseNumber = option.PropertyHouseNumber;
    this.PropertyBoxNumber = option.PropertyBoxNumber;
    this.PropertyPostCode = option.PropertyPostCode;
    this.PropertyCityName = option.PropertyCityName;
    this.ExtraInformation = option.ExtraInformation;
    this.PropertyTypes = option.PropertyTypes || new GenericObject();
    this.CombineInspections = option.CombineInspections || new GenericObject();
    this.Regions = option.Regions || new GenericObject();
    this.Countries = option.Countries || new GenericObject();
    this.AgencyInfos = option.AgencyInfos || [];
    this.OwnerInfos = option.OwnerInfos || [];
    this.ContactInfos = option.ContactInfos || [];
  }
}

export interface IKeuringPublishInfoRequest {
  PropertyId?: number;
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyBoxNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  IsPropertyKey?: boolean;
  ExtraInformation?: string;
  FeedbackTo?: string;
  SendInvoiceType?: IGenericObject;
  ApplyInvoiceType?: IGenericObject;
  CommissionType?: IGenericObject;
  ContactPersonType?: IGenericObject;
  OwnerProfessionType?: IGenericObject;
  PropertyType?: IGenericObject;
  NumberOfResidence?: IGenericObject;
  CombineInspections?: IGenericObject[];
  AgencyInfo?: IKeuringsPlatformInfoModel;
  OwnerInfo?: IKeuringsPlatformInfoModel;
  ContactInfo?: IKeuringsPlatformInfoModel;
  Documents?: any;
}

export class KeuringPublishInfoRequest extends BaseModel<IKeuringPublishInfoRequest> implements IKeuringPublishInfoRequest { 
  PropertyId?: number;
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyBoxNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  IsPropertyKey?: boolean;
  ExtraInformation?: string;
  FeedbackTo?: string;
  SendInvoiceType?: IGenericObject;
  ApplyInvoiceType?: IGenericObject;
  CommissionType?: IGenericObject;
  ContactPersonType?: IGenericObject;
  OwnerProfessionType?: IGenericObject;
  PropertyType?: IGenericObject;
  NumberOfResidence?: IGenericObject;
  CombineInspections?: IGenericObject[];
  AgencyInfo?: IKeuringsPlatformInfoModel;
  OwnerInfo?: IKeuringsPlatformInfoModel;
  ContactInfo?: IKeuringsPlatformInfoModel;
  Documents?: any;
  constructor(option?: IKeuringPublishInfoRequest) {
    super(option);
    this.PropertyId = option.PropertyId || null;
    this.PropertyAddress = option.PropertyAddress || null;
    this.PropertyHouseNumber = option.PropertyHouseNumber || null;
    this.PropertyBoxNumber = option.PropertyBoxNumber || null;
    this.PropertyPostCode = option.PropertyPostCode || null;
    this.PropertyCityName = option.PropertyCityName || null;
    this.IsPropertyKey = option.IsPropertyKey || null;
    this.ExtraInformation = option.ExtraInformation || null;
    this.FeedbackTo = option.FeedbackTo || null;
    this.SendInvoiceType = option.SendInvoiceType || new GenericObject();
    this.ApplyInvoiceType = option.ApplyInvoiceType || new GenericObject();
    this.CommissionType = option.CommissionType || new GenericObject();
    this.ContactPersonType = option.ContactPersonType || new GenericObject();
    this.OwnerProfessionType = option.OwnerProfessionType || new GenericObject();
    this.PropertyType = option.PropertyType || new GenericObject();
    this.NumberOfResidence = option.NumberOfResidence || new GenericObject();
    this.CombineInspections = option.CombineInspections || []
    this.AgencyInfo = option.AgencyInfo || new KeuringsPlatformInfoModel({});
    this.OwnerInfo = option.OwnerInfo || new KeuringsPlatformInfoModel({});
    this.ContactInfo = option.ContactInfo || new KeuringsPlatformInfoModel({});
    this.Documents = option.Documents || []
  }

}


export interface ICertiplusInfoResponse {
  PropertySiteId?: number;
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyBoxNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  ExtraInformation?: string;
  FeedbackTo?: string;
  SendInvoiceTypes?: IGenericObject;
  ApplyInvoiceTypes?: IGenericObject;
  CommissonTypes?: IGenericObject;
  OwnerProfessionTypes?: IGenericObject;
  ContactPersonTypes?: IGenericObject;
  PropertyTypes?: IGenericObject;
  NumberOfResidences?: IGenericObject;
  CombineInspections?: IGenericObject;
  AgencyInfos?: IKeuringsPlatformInfoModel[];
  OwnerInfos?: IKeuringsPlatformInfoModel[];
  ContactInfos?: IKeuringsPlatformInfoModel[];
}

export class CertiplusInfoResponseModel extends BaseModel<ICertiplusInfoResponse> implements ICertiplusInfoResponse { 
  PropertySiteId?: number;
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyBoxNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  ExtraInformation?: string;
  FeedbackTo?: string;
  SendInvoiceTypes?: IGenericObject;
  ApplyInvoiceTypes?: IGenericObject;
  CommissonTypes?: IGenericObject;
  OwnerProfessionTypes?: IGenericObject;
  ContactPersonTypes?: IGenericObject;
  PropertyTypes?: IGenericObject;
  NumberOfResidences?: IGenericObject;
  CombineInspections?: IGenericObject;
  AgencyInfos?: IKeuringsPlatformInfoModel[];
  OwnerInfos?: IKeuringsPlatformInfoModel[];
  ContactInfos?: IKeuringsPlatformInfoModel[];
  constructor(option?: ICertiplusInfoResponse) { 
    super(option);
    this.PropertySiteId = option.PropertySiteId || null;
    this.PropertyAddress = option.PropertyAddress || null;
    this.PropertyHouseNumber = option.PropertyHouseNumber || null;
    this.PropertyBoxNumber = option.PropertyBoxNumber || null;
    this.PropertyPostCode = option.PropertyPostCode || null;
    this.PropertyCityName = option.PropertyCityName || null;
    this.ExtraInformation = option.ExtraInformation || null;
    this.FeedbackTo = option.FeedbackTo || null;
    this.SendInvoiceTypes = option.SendInvoiceTypes || new GenericObject();
    this.ApplyInvoiceTypes = option.ApplyInvoiceTypes || new GenericObject();
    this.CommissonTypes = option.CommissonTypes || new GenericObject();
    this.OwnerProfessionTypes = option.OwnerProfessionTypes || new GenericObject();
    this.ContactPersonTypes = option.ContactPersonTypes || new GenericObject();
    this.PropertyTypes = option.PropertyTypes || new GenericObject();
    this.NumberOfResidences = option.NumberOfResidences || new GenericObject();
    this.CombineInspections = option.CombineInspections || new GenericObject();
    this.AgencyInfos = option.AgencyInfos || []
    this.OwnerInfos = option.OwnerInfos || []
    this.ContactInfos = option.ContactInfos || []
  }
}